var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPopularityEditIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.69273 3.01196L1.85137 10.8522C1.78249 10.9215 1.73286 11.0076 1.70737 11.102L0.0198457 17.2895C-0.00626692 17.3852 -0.00661663 17.4861 0.018832 17.582C0.0442806 17.6778 0.0946227 17.7653 0.164755 17.8354C0.234887 17.9055 0.322315 17.9559 0.418176 17.9813C0.514037 18.0068 0.614923 18.0064 0.710605 17.9803L6.89819 16.2928C6.99254 16.2673 7.07862 16.2177 7.14794 16.1488L14.9882 8.30741L9.69273 3.01196Z",
    fill: "#3397F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.507 3.40337L14.5978 0.494084C14.2813 0.177722 13.8521 0 13.4047 0C12.9572 0 12.5281 0.177722 12.2116 0.494084L10.8875 1.81823L16.1829 7.11368L17.507 5.78953C17.8234 5.47307 18.0011 5.04392 18.0011 4.59645C18.0011 4.14898 17.8234 3.71983 17.507 3.40337Z",
    fill: "#3397F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopularityEditIcon);
export default __webpack_public_path__ + "static/media/popularityEditIcon.63d919eedd289c39aeeacf63fc7938ff.svg";
export { ForwardRef as ReactComponent };